module.exports = __webpack_public_path__ + "img/mrl1.ad220b91.jpg";